import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCopilotNegativeSentimentIconProps extends SvgIconProps {}

/**
 * Component used to display copilot negative sentiment icon
 * @param props - CcfCopilotNegativeSentimentIconProps
 * @returns
 * @example
 */
export function CcfCopilotNegativeSentimentIcon(
  props: CcfCopilotNegativeSentimentIconProps
) {
  return (
    <SvgIcon width="24" height="25" viewBox="0 0 24 25" fill="none" {...props}>
      <g clip-path="url(#clip0_2278_1623)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.25289 11.3388C5.48069 11.111 5.85004 11.111 6.07784 11.3388L8.91788 14.1789C9.04019 14.3012 9.10743 14.3678 9.15945 14.4119C9.16152 14.4137 9.16349 14.4153 9.16536 14.4169C9.16723 14.4153 9.1692 14.4137 9.17128 14.4119C9.22329 14.3678 9.29054 14.3012 9.41285 14.1789L11.0227 12.569C11.1268 12.4649 11.2282 12.3635 11.3211 12.2846C11.4231 12.198 11.5525 12.1049 11.7215 12.05C11.9558 11.9739 12.2082 11.9739 12.4426 12.05C12.6116 12.1049 12.741 12.198 12.843 12.2846C12.9359 12.3635 13.0372 12.4648 13.1413 12.569L16.7487 16.1763V13.5013C16.7487 13.1791 17.0099 12.918 17.332 12.918C17.6542 12.918 17.9154 13.1791 17.9154 13.5013V17.5846C17.9154 17.9068 17.6542 18.168 17.332 18.168H13.2487C12.9265 18.168 12.6654 17.9068 12.6654 17.5846C12.6654 17.2625 12.9265 17.0013 13.2487 17.0013H15.9237L12.3295 13.4071C12.2072 13.2848 12.14 13.2182 12.0879 13.174C12.0859 13.1722 12.0839 13.1706 12.082 13.169C12.0802 13.1706 12.0782 13.1722 12.0761 13.174C12.0241 13.2182 11.9569 13.2848 11.8345 13.4071L10.2247 15.017C10.1206 15.1211 10.0192 15.2225 9.92632 15.3013C9.82432 15.3879 9.69489 15.481 9.52588 15.5359C9.29157 15.612 9.03916 15.612 8.80484 15.5359C8.63584 15.481 8.50641 15.3879 8.40441 15.3013C8.31153 15.2225 8.21016 15.1211 8.10607 15.017C8.10169 15.0126 8.09731 15.0082 8.09292 15.0038L5.25289 12.1638C5.02508 11.936 5.02508 11.5666 5.25289 11.3388Z"
          fill="#C2041A"
          stroke="#C2041A"
          strokeWidth="0.35"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        opacity="0.16"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 9.92718C21.0129 10.6931 19.7732 11.1491 18.4271 11.1491C15.2054 11.1491 12.5938 8.53742 12.5938 5.31576C12.5938 4.49293 12.7641 3.7099 13.0715 3H3.33333C2.04467 3 1 4.04467 1 5.33333V21.6667C1 22.9553 2.04467 24 3.33333 24H19.6667C20.9553 24 22 22.9553 22 21.6667V9.92718Z"
        fill="#F6384E"
      />
      <g clip-path="url(#clip1_2278_1623)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.7442 1.79234C18.6937 1.66093 18.5674 1.57422 18.4266 1.57422C18.2859 1.57422 18.1596 1.66093 18.1091 1.79234L17.4244 3.57237C17.3222 3.83814 17.2901 3.91472 17.2461 3.97652C17.2021 4.03852 17.1479 4.09269 17.0859 4.13677C17.0241 4.18071 16.9475 4.21283 16.6817 4.31505L14.9017 4.99968C14.7703 5.05022 14.6836 5.17648 14.6836 5.31727C14.6836 5.45807 14.7703 5.58433 14.9017 5.63487L16.6817 6.3195C16.9475 6.42172 17.0241 6.45384 17.0859 6.49777C17.1479 6.54186 17.2021 6.59603 17.2461 6.65803C17.2901 6.71982 17.3222 6.79641 17.4244 7.06218L18.1091 8.8422C18.1596 8.97362 18.2859 9.06033 18.4266 9.06033C18.5674 9.06033 18.6937 8.97362 18.7442 8.8422L19.4289 7.06218C19.5311 6.79641 19.5632 6.71982 19.6071 6.65803C19.6512 6.59603 19.7054 6.54186 19.7674 6.49777C19.8292 6.45384 19.9058 6.42171 20.1716 6.31949L21.9516 5.63487C22.083 5.58433 22.1697 5.45807 22.1697 5.31727C22.1697 5.17648 22.083 5.05022 21.9516 4.99968L20.1716 4.31505C19.9058 4.21283 19.8292 4.18071 19.7674 4.13677C19.7054 4.09269 19.6512 4.03852 19.6071 3.97652C19.5632 3.91472 19.5311 3.83814 19.4289 3.57237L18.7442 1.79234Z"
          fill="#C2041A"
        />
      </g>
      <defs>
        <clipPath id="clip0_2278_1623">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(4.5 6.5)"
          />
        </clipPath>
        <clipPath id="clip1_2278_1623">
          <rect
            width="8.16667"
            height="8.16667"
            fill="white"
            transform="translate(14.3438 1.23242)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default CcfCopilotNegativeSentimentIcon;
